import "@templeos/ui/styles.css";
import "./pos.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App.js";

// The service worker (vite-plugin-pwa, registered automatically) caches the app shell so the counter opens offline.
document.body.classList.add("tos-root", "pos-root");
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
